import { scroller } from 'react-scroll'

function scrollTo(id, scrollOffset=-70, scrollDuration=500) {
  if (typeof document !== 'undefined') {
    scroller.scrollTo(id, {
      duration: scrollDuration,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: scrollOffset
    });
  }
}

export default {
  scrollTo
}
